module.exports = __webpack_public_path__ + "img/sitios.0d87e8d7.png";